import LoadingGif from '../../assets/loading.gif';
import Styles from './Loading.module.css';

const Loading = () => {
  return (
    <div className={Styles.loadingContainer}>
      <img src={LoadingGif} alt="Loading..." className={Styles.loadingGif} />
      <p>Loading...</p>
    </div>
  );
};

export default Loading;
